import { AddContactForSeriesRequest } from '~/domain/Contacts'
import { ApiError } from './error'

export const addContactForSeries = async (email: string, seriesId: string) => {
  const method = 'POST'
  const headers = { 'content-type': 'application/json; charset=UTF-8' }
  const requestBody: AddContactForSeriesRequest = { email, seriesId }
  const body = JSON.stringify(requestBody)
  const path = '/api/contacts'

  const response = await fetch(path, { method, headers, body })

  if (response.status !== 200) {
    throw new ApiError(method, path, response.status)
  }
}
